module.exports = __webpack_public_path__ + "img/quizzort_top_board.6dfaa0c1.png";